<template>
    <div class="calendar">

        <div class="calendar-size">
            <div v-for="activity in activities" :key="activity.date + activity.hour" class="agenda">
                <div class="column-0"> {{ activity.date }} </div>
                <div class="column">
                    <strong style="margin-right: 7px"> {{ activity.hour }} </strong>
                    {{ activity.name }}
                </div>
                <div class="column"> {{ activity.place }} </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    data() {
        return {
            activities: [
                {date: '15 nov', hour: '4:00pm' ,name: 'Check in', place: 'Lobby Villa Varadero'},
                {date: '16 nov', hour: '4:30pm' ,name: 'Ceremonia religiosa', place: 'Parroquia La Sagrada Familia'},
                {date: '', hour: '6:00pm' ,name: 'Cóctel de bienvenida y fotografía', place: 'Playa del Hotel Villa Varadero'},
                {date: '', hour: '7:00pm' ,name: 'Cena', place: ''},
                {date: '', hour: '8:00pm' ,name: 'Baile', place: ''},
                {date: '18 nov', hour: '11:00am' ,name: 'Checkout', place: 'Lobby Villa Varadero'}
            ]
        }
    }
}
</script>

<style lang="scss" scoped>

@import "./variables.scss";

.agenda {
    display: flex;
    &:nth-child(odd) {
        background: lightcyan;
    }
}

.calendar {
    display: flex;
    font-size: 18px;
    font-family: Avenir,Helvetica,Arial,sans-serif;
    justify-content: center;
    @media screen and (max-width: $break-md) {
        font-size: 17px;
    }
    @media screen and (max-width: $break-sm) {
        font-size: 15px;
    }
    @media screen and (max-width: 300px) {
        font-size: 11px;
    }
}

.calendar-size {
    width: 50%;
    @media screen and (max-width: $break-lg) {
        width: 70%;
    }
    @media screen and (max-width: $break-md) {
        width: 90%;
    }
}

.column {
    flex: 2;
    display: flex;
    padding: 0 10px;
    text-align: initial;
    border-left: 1px solid lightslategrey;
    @media screen and (max-width: $break-sm) {
        flex-direction: column;
    }
}

.column-0 {
    flex: 1;
    text-align: end;
    padding: 0 10px;
    font-weight: 600;
}

</style>